import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { Dropdown, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";

const UiMeet3dMobileMenu = observer(({ active, t }) => (
  <Dropdown text="Menu" floating button icon="dropdown" className="tour-mobile-menu-wrap">
    <Dropdown.Menu position="right">
      <Dropdown.Item as={Link} to="/ui-meet-3d" active={active === UiMeet3dNav.HOME}>
        <Icon name="home" />
        {t("home")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/general" active={active === UiMeet3dNav.GENERAL}>
        <Icon name="flag" />
        {t("general")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/greeting-bot" active={active === UiMeet3dNav.GREETING_BOT}>
        <Icon name="user circle" />
        {t("clientPanelMisc:greetingBot")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/notifications" active={active === UiMeet3dNav.NOTIFICATIONS}>
        <Icon name="mail" />
        {t("clientPanelMisc:notifications")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/events" active={active === UiMeet3dNav.EVENTS}>
        <Icon name="bullhorn" />
        {t("clientPanelMisc:events")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/leads" active={active === UiMeet3dNav.LEADS}>
        <Icon name="bullseye" />
        {t("clientPanelMisc:leads")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} to="/ui-meet-3d/meetings" active={active === UiMeet3dNav.COMPLETED_MEETINGS}>
        <Icon name="users" />
        {t("clientPanelMisc:meetings")}
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
));

UiMeet3dMobileMenu.propTypes = {
  active: PropTypes.string,
  t: PropTypes.func.isRequired,
};

UiMeet3dMobileMenu.defaultProps = {
  active: "",
};

export default withTranslation()(UiMeet3dMobileMenu);
